module.exports = __webpack_public_path__ + "static/media/projectsIcon.e285bd78.png";